import { z } from 'zod'

const optionalJsonRecordSchema = z.string().refine((val) => {
  if (!val) return true
  try {
    const parsed = JSON.parse(val)
    return typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed)
  } catch {
    return false
  }
}, 'Must be valid JSON, e.g. {"Elevator": "1244545677"}')

export const IglooWorksConnectionSchema = z.object({
  clientId: z.string().min(1, 'Client ID is required'),
  clientSecret: z.string().min(1, 'Client Secret is required'),
  permissionDoors: optionalJsonRecordSchema,
  shouldAutoAssignApartmentDoor: z.boolean(),
  shouldAutoAssignApartmentDoorVisitor: z.boolean(),
  visitorPermissionDoors: optionalJsonRecordSchema,
})

export type IglooWorksConnectionFormValues = z.infer<typeof IglooWorksConnectionSchema>

export const iglooWorksDefaultValues: IglooWorksConnectionFormValues = {
  clientId: '',
  clientSecret: '',
  permissionDoors: '',
  shouldAutoAssignApartmentDoor: false,
  shouldAutoAssignApartmentDoorVisitor: false,
  visitorPermissionDoors: '',
}
